import React from 'react';
import { Redirect } from 'react-router-dom';

import { usePlanFeatureGate } from './use-plan-feature-gate';
import { pages } from '../pages/settings/nav-items';

/**
 * @typedef {import('../constants/features-type.d.ts').FeatureCode} FeatureCode
 */

/**
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {FeatureCode} props.featureCode
 * @returns {React.ReactNode}
 */
export const FeatureGatedRoute = ({ children, featureCode }) => {
  const { isFeatureEnabled } = usePlanFeatureGate(featureCode);

  if (isFeatureEnabled) {
    return children;
  }

  return <Redirect to={`/${pages.settings.location}/${pages.paymentAndSubscription.location}`} />;
};
